!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Sudoku = e() : t.Sudoku = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 5);
  }([function (t, e, n) {
    "use strict";

    function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var i = function () {
      function t(e, n, r) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.id = e, this.cells = n, this.grid = r, this;
      }

      return function (t, e, n) {
        e && r(t.prototype, e), n && r(t, n);
      }(t, [{
        key: "isSolved",
        get: function get() {
          return 9 === this.usedCells.length;
        }
      }, {
        key: "unused",
        get: function get() {
          var t = this;
          return new Set([1, 2, 3, 4, 5, 6, 7, 8, 9].filter(function (e) {
            return !t.used.has(e);
          }));
        }
      }, {
        key: "used",
        get: function get() {
          return new Set(this.usedCells.map(function (t) {
            return t.digit;
          }));
        }
      }, {
        key: "usedCells",
        get: function get() {
          return this.cells.filter(function (t) {
            return 0 !== t.digit;
          });
        }
      }, {
        key: "unusedCells",
        get: function get() {
          return this.cells.filter(function (t) {
            return 0 === t.digit;
          });
        }
      }, {
        key: "links",
        get: function get() {
          var t = this,
              e = {},
              n = !0,
              r = !1,
              i = void 0;

          try {
            for (var o, u = function u() {
              var n = o.value,
                  r = t.cells.filter(function (t) {
                return t.possibilities.has(n) && 2 === t.possibilities.size;
              }).map(function (t) {
                return {
                  id: t.id,
                  possibilities: t.possibilities
                };
              });
              r.length > 1 && (e[n] = r);
            }, l = this.unused[Symbol.iterator](); !(n = (o = l.next()).done); n = !0) {
              u();
            }
          } catch (t) {
            r = !0, i = t;
          } finally {
            try {
              n || null == l.return || l.return();
            } finally {
              if (r) throw i;
            }
          }

          return e;
        }
      }]), t;
    }();

    e.default = i;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(n(6)),
        i = s(n(8)),
        o = s(n(9)),
        u = s(n(10)),
        l = s(n(11)),
        f = s(n(12)),
        c = s(n(13)),
        a = s(n(14));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function d(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var y = [new i.default(), new o.default(), new u.default(), new l.default(), new f.default(), new a.default(), new c.default()],
        h = function () {
      function t(e) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.grid = new r.default(e), this;
      }

      return function (t, e, n) {
        e && d(t.prototype, e), n && d(t, n);
      }(t, [{
        key: "isSolved",
        value: function value() {
          for (var t = !0, e = 0; e < 9; e++) {
            !1 === this.grid.row[e].isSolved && (t = !1);
          }

          return t;
        }
      }, {
        key: "next",
        value: function value() {
          var t;

          for (var e in y) {
            if (t = y[e].find(this.grid), t) return t;
          }
        }
      }, {
        key: "solve",
        value: function value() {
          for (var t = this.next(); !this.isSolved() && t;) {
            this.apply(t), t = this.next(), 1;
          }

          return this;
        }
      }, {
        key: "apply",
        value: function value(t) {
          t.strategy.apply(this.grid, t);
        }
      }, {
        key: "firstRow",
        value: function value() {
          return this.grid.row[0].cells.map(function (t) {
            return t.digit;
          });
        }
      }]), t;
    }();

    e.default = h;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isRow = function (t) {
      return t.every(function (t, e, n) {
        return t.rowID === n[0].rowID;
      });
    }, e.default = void 0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(0));

    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function o(t, e) {
      return !e || "object" !== i(e) && "function" != typeof e ? f(t) : e;
    }

    function u(t) {
      return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function l(t, e) {
      return (l = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function f(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    var c = function (t) {
      function e(t, n, r) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (i = o(this, u(e).call(this, t, n, r))).type = "row", o(i, f(f(i)));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && l(t, e);
      }(e, r.default), e;
    }();

    e.default = c;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isColumn = function (t) {
      return t.every(function (t, e, n) {
        return t.columnID === n[0].columnID;
      });
    }, e.default = void 0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(0));

    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function o(t, e) {
      return !e || "object" !== i(e) && "function" != typeof e ? f(t) : e;
    }

    function u(t) {
      return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function l(t, e) {
      return (l = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function f(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    var c = function (t) {
      function e(t, n, r) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (i = o(this, u(e).call(this, t, n, r))).type = "column", o(i, f(f(i)));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && l(t, e);
      }(e, r.default), e;
    }();

    e.default = c;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isSquare = function (t) {
      return t.every(function (t, e, n) {
        return t.squareID === n[0].squareID;
      });
    }, e.default = void 0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(0));

    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function o(t, e) {
      return !e || "object" !== i(e) && "function" != typeof e ? f(t) : e;
    }

    function u(t) {
      return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function l(t, e) {
      return (l = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function f(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    var c = function (t) {
      function e(t, n, r) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (i = o(this, u(e).call(this, t, n, r))).type = "square", o(i, f(f(i)));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && l(t, e);
      }(e, r.default), e;
    }();

    e.default = c;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "Solver", {
      enumerable: !0,
      get: function get() {
        return r.default;
      }
    }), Object.defineProperty(e, "isValid", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    });
    var r = o(n(1)),
        i = o(n(15));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = l(n(7)),
        i = l(n(2)),
        o = l(n(3)),
        u = l(n(4));

    function l(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function f(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var a = function () {
      function t(e) {
        var n;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.cells = this.textToCells(e), this.square = [], this.row = [], this.column = [], this.house = [];

        for (var r = 0; r < 9; r++) {
          this.row.push(new i.default(r, this.getRow(r), this)), this.column.push(new o.default(r, this.getColumn(r), this)), this.square.push(new u.default(r, this.getSquare(r), this));
        }

        (n = this.house).push.apply(n, f(this.row).concat(f(this.column), f(this.square)));
      }

      return function (t, e, n) {
        e && c(t.prototype, e), n && c(t, n);
      }(t, [{
        key: "textToCells",
        value: function value(t) {
          for (var e = [], n = t.match(/.{1,9}/g), i = [], o = 0; o < 9; o++) {
            i[o] = n[o].split("").map(Number);
          }

          for (var u = 0; u < 9; u++) {
            for (var l = 0; l < 9; l++) {
              var f = !!i[u][l];
              e.push(new r.default(this, u, l, i[u][l], f));
            }
          }

          return e;
        }
      }, {
        key: "getSquare",
        value: function value(t) {
          return this.cells.filter(function (e) {
            return e.squareID === t;
          });
        }
      }, {
        key: "getRow",
        value: function value(t) {
          return this.cells.filter(function (e) {
            return e.rowID === t;
          });
        }
      }, {
        key: "getColumn",
        value: function value(t) {
          return this.cells.filter(function (e) {
            return e.columnID === t;
          });
        }
      }]), t;
    }();

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var o = function () {
      function t(e, n, r, i, o) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.id = 9 * n + r, this.grid = e, this.rowID = n, this.columnID = r, this.locked = o, this.squareID = 3 * Math.floor(n / 3) + Math.floor(r / 3), this.impossibilities = [], this._digit = i, this.row = "R".concat(this.rowID + 1), this.column = "C".concat(this.columnID + 1), this.square = "S".concat(this.squareID + 1), this;
      }

      return function (t, e, n) {
        e && i(t.prototype, e), n && i(t, n);
      }(t, [{
        key: "getPossibilities",
        value: function value() {
          if (this.digit) return new Set();

          for (var t = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9]), e = 0; e < this.impossibilities.length; e++) {
            t.delete(this.impossibilities[e]);
          }

          var n = this.grid.square[this.squareID].cells.map(function (t) {
            return t.digit;
          }).filter(function (t) {
            return 0 !== t;
          }),
              i = this.grid.row[this.rowID].cells.map(function (t) {
            return t.digit;
          }).filter(function (t) {
            return 0 !== t;
          }),
              o = this.grid.column[this.columnID].cells.map(function (t) {
            return t.digit;
          }).filter(function (t) {
            return 0 !== t;
          }),
              u = new Set(i.concat(o).concat(n));
          return new Set(r(t).filter(function (t) {
            return !u.has(t);
          }));
        }
      }, {
        key: "addToImpossibilities",
        value: function value(t) {
          return this.impossibilities.push(t), this.impossibilities;
        }
      }, {
        key: "digit",
        get: function get() {
          return this._digit;
        },
        set: function set(t) {
          var e = this;
          this.grid.row[this.rowID].used.add(t), this.grid.row[this.rowID].unused.delete(t), this.grid.column[this.columnID].used.add(t), this.grid.column[this.columnID].unused.delete(t), this.grid.square[this.squareID].used.add(t), this.grid.square[this.squareID].unused.delete(t), this.grid.row[this.rowID].cells.filter(function (t) {
            return t.id !== e.id;
          }).forEach(function (e) {
            return e.impossibilities.concat(t);
          }), this.grid.column[this.columnID].cells.filter(function (t) {
            return t.id !== e.id;
          }).forEach(function (e) {
            return e.impossibilities.concat(t);
          }), this.grid.square[this.squareID].cells.filter(function (t) {
            return t.id !== e.id;
          }).forEach(function (e) {
            return e.impossibilities.concat(t);
          }), this._digit = t;
        }
      }, {
        key: "possibilities",
        get: function get() {
          return this.getPossibilities();
        }
      }, {
        key: "canSee",
        get: function get() {
          var t = this.grid.square[this.squareID].cells,
              e = this.grid.row[this.rowID].cells,
              n = this.grid.column[this.columnID].cells;
          return new Set(e.concat(n).concat(t));
        }
      }]), t;
    }();

    e.default = o;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function i(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var o = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "NakedSingle", this;
      }

      return function (t, e, n) {
        e && r(t.prototype, e), n && r(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          var e = t.cells.filter(function (t) {
            return 1 === t.possibilities.size;
          });

          if (e.length) {
            var n = e[0],
                r = n.possibilities.values().next().value,
                o = function (t, e) {
              for (var n = [], r = ["row", "column", "square"], o = 0; o < r.length; o++) {
                var u = r[o],
                    l = t[u + "ID"],
                    f = e[u][l].cells;
                if (8 === f.filter(function (t) {
                  return t.digit > 0;
                }).length) return n = f.filter(function (t) {
                  return t.digit > 0;
                }).map(function (t) {
                  return t.id;
                });
              }

              for (var c = i(t.canSee), a = function a(t) {
                var e = c.filter(function (e) {
                  return e.digit === t;
                }).map(function (t) {
                  return t.id;
                }).map(Number)[0];
                isNaN(e) || n.push(e);
              }, s = 1; s <= 9; s++) {
                a(s);
              }

              return n;
            }(n, t);

            return {
              id: n.id,
              digit: r,
              used: o,
              strategy: this
            };
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          t.cells[e.id].digit = e.digit;
        }
      }]), t;
    }();

    e.default = o;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var o = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "HiddenSingle", this;
      }

      return function (t, e, n) {
        e && i(t.prototype, e), n && i(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          var e = this,
              n = t.house.filter(function (t) {
            return t.unused.size > 1;
          }),
              i = !0,
              o = !1,
              u = void 0;

          try {
            for (var l, f = n[Symbol.iterator](); !(i = (l = f.next()).done); i = !0) {
              var c = l.value,
                  a = !0,
                  s = !1,
                  d = void 0;

              try {
                for (var y, h = function h() {
                  var t = y.value,
                      n = c.cells.filter(function (e) {
                    return e.possibilities.has(t);
                  });
                  if (1 === n.length) return {
                    v: {
                      id: n[0].id,
                      digit: t,
                      house: c,
                      strategy: e
                    }
                  };
                }, p = c.unused.values()[Symbol.iterator](); !(a = (y = p.next()).done); a = !0) {
                  var v = h();
                  if ("object" === r(v)) return v.v;
                }
              } catch (t) {
                s = !0, d = t;
              } finally {
                try {
                  a || null == p.return || p.return();
                } finally {
                  if (s) throw d;
                }
              }
            }
          } catch (t) {
            o = !0, u = t;
          } finally {
            try {
              i || null == f.return || f.return();
            } finally {
              if (o) throw u;
            }
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          t.cells[e.id].digit = e.digit;
        }
      }]), t;
    }();

    e.default = o;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function o(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var u = function u(t, e, n) {
      return t.cells.filter(function (t) {
        return -1 === e.indexOf(t.id);
      }).filter(function (t) {
        return o(t.possibilities).some(function (t) {
          return n.indexOf(t) > -1;
        });
      });
    },
        l = function l(t, e, n) {
      return !!u(t, e, n).length;
    },
        f = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "Naked", this;
      }

      return function (t, e, n) {
        e && i(t.prototype, e), n && i(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          for (var e, n = this, i = function i(_i) {
            e = t.house.filter(function (t) {
              return t.unused.size > _i;
            });
            var u = !0,
                f = !1,
                c = void 0;

            try {
              for (var a, s = e[Symbol.iterator](); !(u = (a = s.next()).done); u = !0) {
                var d = a.value,
                    y = d.cells.filter(function (t) {
                  return t.possibilities.size <= _i;
                }).map(function (t) {
                  return o(t.possibilities);
                }),
                    h = !0,
                    p = !1,
                    v = void 0;

                try {
                  for (var b, m = function m() {
                    var t = b.value,
                        e = d.unusedCells.filter(function (e) {
                      return o(e.possibilities).every(function (e) {
                        return t.indexOf(e) > -1;
                      });
                    });

                    if (e.length === _i) {
                      var r = e.map(function (t) {
                        return t.id;
                      }),
                          u = t;
                      if (l(d, r, u)) return {
                        v: {
                          v: {
                            id: r,
                            digits: u,
                            house: d,
                            length: _i,
                            strategy: n
                          }
                        }
                      };
                    }
                  }, g = y[Symbol.iterator](); !(h = (b = g.next()).done); h = !0) {
                    var w = m();
                    if ("object" === r(w)) return w.v;
                  }
                } catch (t) {
                  p = !0, v = t;
                } finally {
                  try {
                    h || null == g.return || g.return();
                  } finally {
                    if (p) throw v;
                  }
                }
              }
            } catch (t) {
              f = !0, c = t;
            } finally {
              try {
                u || null == s.return || s.return();
              } finally {
                if (f) throw c;
              }
            }
          }, u = 2; u <= 4; u++) {
            var f = i(u);
            if ("object" === r(f)) return f.v;
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          return u(e.house, e.id, e.digits).forEach(function (t) {
            t.impossibilities = t.impossibilities.concat(e.digits);
          }), !0;
        }
      }]), t;
    }();

    e.default = f;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function o(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var u = function u(t, e) {
      return !!t.filter(function (t) {
        return t.possibilities.size > e.length;
      }).length;
    },
        l = function l(t, e) {
      return function t(e, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
        if (r.length || e.length) return e.length ? (t(e.slice(1), n, r.concat(e[0]), i), t(e.slice(1), n, r, i)) : r.length === n && i.push(r), i;
      }(t, e);
    },
        f = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "Hidden", this;
      }

      return function (t, e, n) {
        e && o(t.prototype, e), n && o(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          for (var e = this, n = function n(_n) {
            var o = t.house.filter(function (t) {
              return t.unused.size >= _n + (_n - 1);
            }),
                f = !0,
                c = !1,
                a = void 0;

            try {
              for (var s, d = o[Symbol.iterator](); !(f = (s = d.next()).done); f = !0) {
                var y = s.value,
                    h = l(r(y.unused), _n),
                    p = !0,
                    v = !1,
                    b = void 0;

                try {
                  for (var m, g = function g() {
                    var t = m.value,
                        i = y.unusedCells.filter(function (e) {
                      return r(e.possibilities).some(function (e) {
                        return t.indexOf(e) > -1;
                      });
                    });
                    if (i.length === _n && u(i, t)) return {
                      v: {
                        v: {
                          id: i.map(function (t) {
                            return t.id;
                          }),
                          digits: t,
                          house: y,
                          length: _n,
                          strategy: e
                        }
                      }
                    };
                  }, w = h[Symbol.iterator](); !(p = (m = w.next()).done); p = !0) {
                    var S = g();
                    if ("object" === i(S)) return S.v;
                  }
                } catch (t) {
                  v = !0, b = t;
                } finally {
                  try {
                    p || null == w.return || w.return();
                  } finally {
                    if (v) throw b;
                  }
                }
              }
            } catch (t) {
              c = !0, a = t;
            } finally {
              try {
                f || null == d.return || d.return();
              } finally {
                if (c) throw a;
              }
            }
          }, o = 2; o <= 4; o++) {
            var f = n(o);
            if ("object" === i(f)) return f.v;
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          return e.house.cells.filter(function (t) {
            return e.id.indexOf(t.id) > -1;
          }).forEach(function (t) {
            var n,
                i = r(t.possibilities).filter(function (t) {
              return -1 === e.digits.indexOf(t);
            });
            t.impossibilities = (n = t.impossibilities).concat.apply(n, r(i));
          }), !0;
        }
      }]), t;
    }();

    e.default = f;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = n(4),
        i = n(2),
        o = n(3);

    function u(t) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function l(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var f = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "LockedCandidate", this;
      }

      return function (t, e, n) {
        e && l(t.prototype, e), n && l(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          var e = this,
              n = t.house.filter(function (t) {
            return t.unused.size > 0;
          }),
              l = !0,
              f = !1,
              c = void 0;

          try {
            for (var a, s = n[Symbol.iterator](); !(l = (a = s.next()).done); l = !0) {
              var d = a.value;

              switch (d.type) {
                case "row":
                case "column":
                  var y = !0,
                      h = !1,
                      p = void 0;

                  try {
                    for (var v, b = function b() {
                      var n = v.value,
                          i = d.cells.filter(function (t) {
                        return t.possibilities.has(n);
                      });

                      if ((0, r.isSquare)(i)) {
                        var o = i[0].squareID,
                            u = t.square[o].cells.filter(function (t) {
                          return t.possibilities.has(n);
                        });

                        if (i.length < u.length) {
                          var l = t.square[o];
                          return {
                            v: {
                              ids: i.map(function (t) {
                                return t.id;
                              }),
                              digit: n,
                              house: d,
                              locked: l,
                              strategy: e
                            }
                          };
                        }
                      }
                    }, m = d.unused[Symbol.iterator](); !(y = (v = m.next()).done); y = !0) {
                      var g = b();
                      if ("object" === u(g)) return g.v;
                    }
                  } catch (t) {
                    h = !0, p = t;
                  } finally {
                    try {
                      y || null == m.return || m.return();
                    } finally {
                      if (h) throw p;
                    }
                  }

                  break;

                case "square":
                  var w = !0,
                      S = !1,
                      O = void 0;

                  try {
                    for (var j, _ = function _() {
                      var n = j.value,
                          r = d.cells.filter(function (t) {
                        return t.possibilities.has(n);
                      });

                      if ((0, i.isRow)(r)) {
                        var u = r[0].rowID,
                            l = t.row[u].cells.filter(function (t) {
                          return t.possibilities.has(n);
                        });

                        if (r.length < l.length) {
                          var f = t.row[u];
                          return {
                            v: {
                              ids: r.map(function (t) {
                                return t.id;
                              }),
                              digit: n,
                              house: d,
                              locked: f,
                              strategy: e
                            }
                          };
                        }
                      }

                      if ((0, o.isColumn)(r)) {
                        var c = r[0].columnID,
                            a = t.column[c].cells.filter(function (t) {
                          return t.possibilities.has(n);
                        });

                        if (r.length < a.length) {
                          var s = t.column[c];
                          return {
                            v: {
                              ids: r.map(function (t) {
                                return t.id;
                              }),
                              digit: n,
                              house: d,
                              locked: s,
                              strategy: e
                            }
                          };
                        }
                      }
                    }, I = d.unused[Symbol.iterator](); !(w = (j = I.next()).done); w = !0) {
                      var k = _();

                      if ("object" === u(k)) return k.v;
                    }
                  } catch (t) {
                    S = !0, O = t;
                  } finally {
                    try {
                      w || null == I.return || I.return();
                    } finally {
                      if (S) throw O;
                    }
                  }

              }
            }
          } catch (t) {
            f = !0, c = t;
          } finally {
            try {
              l || null == s.return || s.return();
            } finally {
              if (f) throw c;
            }
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          return t[e.locked.type][e.locked.id].cells.filter(function (t) {
            return -1 === e.ids.indexOf(t.id);
          }).filter(function (t) {
            return t.possibilities.has(e.digit);
          }).forEach(function (t) {
            t.addToImpossibilities(e.digit);
          }), !0;
        }
      }]), t;
    }();

    e.default = f;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function o(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var u = function t(e, n, r, i) {
      var u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
          l = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : [],
          f = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : [],
          c = function c(n, _c) {
        var s = n.links[_c.mustBe].filter(function (t) {
          return -1 === l.indexOf(t.id);
        }).filter(function (t) {
          return t.id !== a.id;
        });

        if (s.length) {
          var d = e.cells[s[0].id],
              y = o(d.possibilities.values()).filter(function (t) {
            return t !== _c.mustBe;
          })[0],
              h = o(d.possibilities.values()).filter(function (t) {
            return t !== y;
          })[0];
          t(e, {
            cell: d,
            mustBe: y,
            cannotBe: h
          }, r.filter(function (t) {
            return t.id !== a.id;
          }), i, u.slice(0), l, f);
        }
      },
          a = n.cell;

      if (u.push(n), r.length && !(u.length > i)) return n.mustBe === u[0].cannotBe ? function (t, e) {
        var n = o(e[0].cell.canSee).filter(function (e) {
          return t.cell.canSee.has(e);
        }).filter(function (e) {
          return e.possibilities.has(t.mustBe);
        }),
            r = e[0].cell.rowID === t.cell.rowID,
            i = e[0].cell.columnID === t.cell.columnID,
            u = e[0].cell.squareID === t.cell.squareID;
        !n.length || r || i || u || (l.push(t.cell.id), f.push(e));
      }(n, u) : (e.row[a.rowID].links[n.mustBe] && c(e.row[a.rowID], n), e.column[a.columnID].links[n.mustBe] && c(e.column[a.columnID], n), e.square[a.squareID].links[n.mustBe] && c(e.square[a.squareID], n)), f;
    },
        l = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "XYChain", this;
      }

      return function (t, e, n) {
        e && i(t.prototype, e), n && i(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          for (var e = this, n = (t.house.filter(function (t) {
            return t.unused.size > 0;
          }), 3); n <= 10; n++) {
            for (var i = function i(_i2) {
              for (var l = t.cells.filter(function (t) {
                return 2 === t.possibilities.size;
              }), f = l.filter(function (t) {
                return t.possibilities.has(_i2);
              }), c = function c() {
                var r = f[0];
                f = f.filter(function (t) {
                  return t.id !== r.id;
                }), l = l.filter(function (t) {
                  return t.id !== r.id;
                });
                var c = o(r.possibilities).filter(function (t) {
                  return t !== _i2;
                })[0],
                    a = u(t, {
                  cell: r,
                  mustBe: c,
                  cannotBe: _i2
                }, l.map(function (t) {
                  return t.id;
                }), n);

                if (a && a.length && a[0].length) {
                  var s,
                      d = (s = []).concat.apply(s, o(a));
                  return {
                    v: {
                      v: {
                        chain: d,
                        type: "XYChain",
                        length: d.length,
                        strategy: e
                      }
                    }
                  };
                }
              }; f.length;) {
                var a = c();
                if ("object" === r(a)) return a.v;
              }
            }, l = 1; l <= 9; l++) {
              var f = i(l);
              if ("object" === r(f)) return f.v;
            }
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          var n = e.chain[0],
              r = e.chain[e.chain.length - 1];
          return o(n.cell.canSee).filter(function (t) {
            return r.cell.canSee.has(t);
          }).filter(function (t) {
            return t.possibilities.has(n.cannotBe);
          }).forEach(function (t) {
            t.addToImpossibilities(r.mustBe);
          });
        }
      }]), t;
    }();

    e.default = l;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function i(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var o = function o(t) {
      return function (e) {
        return e.cells.filter(function (e) {
          return e.possibilities.has(t);
        }).length >= 2;
      };
    },
        u = function u(t) {
      return function (e) {
        var n = e.cells.filter(function (e) {
          return e.possibilities.has(t);
        }).map(function (t) {
          return t.columnID;
        });
        return {
          rowID: e.id,
          columnIDs: n
        };
      };
    },
        l = function l(t, e) {
      for (var n = [], r = function r(_r) {
        var o = e.find(function (e) {
          return e.rowID === t[_r];
        }).columnIDs;
        n.push.apply(n, i(o));
      }, o = 0; o < t.length; o++) {
        r(o);
      }

      return i(new Set(n));
    },
        f = function f(t, e, n, r) {
      return t.cells.filter(function (t) {
        return t.possibilities.has(e);
      }).filter(function (t) {
        return -1 === n.indexOf(t.rowID);
      }).filter(function (t) {
        return r.indexOf(t.columnID) > -1;
      }).length;
    },
        c = function c(t, e) {
      return function t(e, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
        if (r.length || e.length) return e.length ? (t(e.slice(1), n, r.concat(e[0]), i), t(e.slice(1), n, r, i)) : r.length === n && i.push(r), i;
      }(t, e);
    },
        a = function () {
      function t() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.type = "Fish", this;
      }

      return function (t, e, n) {
        e && r(t.prototype, e), n && r(t, n);
      }(t, [{
        key: "find",
        value: function value(t) {
          for (var e = 1; e <= 9; e++) {
            var n = t.row.filter(o(e));
            if (n.length) for (var r = n.map(u(e)).filter(function (t) {
              return t.columnIDs.length >= 2;
            }), i = 2; i <= 4; i++) {
              var a = r.map(function (t) {
                return t.rowID;
              }),
                  s = c(a, i),
                  d = !0,
                  y = !1,
                  h = void 0;

              try {
                for (var p, v = s[Symbol.iterator](); !(d = (p = v.next()).done); d = !0) {
                  var b = p.value,
                      m = l(b, r);

                  if (m.length === i) {
                    var g = b;
                    if (f(t, e, g, m)) return {
                      digit: e,
                      rows: g,
                      columns: m,
                      length: g.length,
                      strategy: this
                    };
                  }
                }
              } catch (t) {
                y = !0, h = t;
              } finally {
                try {
                  d || null == v.return || v.return();
                } finally {
                  if (y) throw h;
                }
              }
            }
          }
        }
      }, {
        key: "apply",
        value: function value(t, e) {
          return t.cells.filter(function (t) {
            return t.possibilities.has(e.digit);
          }).filter(function (t) {
            return -1 === e.rows.indexOf(t.rowID);
          }).filter(function (t) {
            return e.columns.indexOf(t.columnID) > -1;
          }).forEach(function (t) {
            t.addToImpossibilities(e.digit);
          }), !0;
        }
      }]), t;
    }();

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      function e(t) {
        return t.length - new Set(t).size;
      }

      for (var n = t.match(/.{1,9}/g), i = {
        row: [],
        column: [],
        square: []
      }, o = 0; o < 9; o++) {
        i.row[o] = [], i.column[o] = [], i.square[o] = [];
      }

      if (9 !== n.length) return {
        isValid: !1,
        message: "Grid does not contain 9 rows"
      };

      for (var u = [], l = 0; l < 9; l++) {
        if (9 !== (u = n[l].split("")).length) return {
          isValid: !1,
          message: "Grid does not contain 9 numbers in row"
        };
        if (9 !== (u = u.map(Number).filter(function (t) {
          return !isNaN(t);
        })).length) return {
          isValid: !1,
          message: "Grid contains non numeric values"
        };
        i.row[l] = u;

        for (var f = 0; f < 9; f++) {
          var c = 3 * Math.floor(l / 3) + Math.floor(f / 3);
          i.column[f].push(u[f]), i.square[c].push(u[f]);
        }
      }

      for (var a = ["row", "column", "square"], s = 0; s < a.length; s++) {
        for (var d = a[s], y = 0, h = 0; h < 9; h++) {
          var p = i[d][h].filter(function (t) {
            return 0 !== t;
          });
          if (p.length && (y += p.length, e(p))) return {
            isValid: !1,
            message: "Grid contains duplicates in ".concat(d, " ").concat(h + 1)
          };
        }

        if (y < 17) return {
          isValid: !1,
          message: "Grid contains less than 17 digits"
        };
      }

      if (new r.default(t).solve().isSolved()) return {
        isValid: !0,
        message: "Grid can be solved"
      };
      return {
        isValid: !1,
        message: "Grid can not be solved by this tool"
      };
    };

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(1));
  }]);
});